
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useConstant } from './use-constant.mjs.js';

var counter = 0;
var incrementId = function () { return counter++; };
var useId = function () { return useConstant(incrementId); };

export { useId };
//# sourceMappingURL=use-id.mjs.js.map
